import { useCategoriaProductoStore } from '@/store/erp';
import { useTypeInstalation } from '@/store/erp/system-settings/type-instalation';
// import { usePaymentMethodsStore } from '@/store/erp/system-settings/payment-methods';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export type TecnicoModuleProps = {};

const TecnicoModule: React.FC<TecnicoModuleProps> = () => {
  const { getCategoriaProducto } = useCategoriaProductoStore();
  const getTypeInstalation = useTypeInstalation(s => s.getTypeInstalation);
  // const { getpaymentMethodsFilterPaging } = usePaymentMethodsStore();
  useEffect(() => {
    (async () => {
      const results = await Promise.allSettled([
        getCategoriaProducto({ page_size: 600 }),
        // getpaymentMethodsFilterPaging({aplica_home:false,aplica_pyme:false,aplica_corporativo:false})
        getTypeInstalation({
          page_size: 1000,
        }),
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);
  return (
      <Outlet />
  );
};

export default TecnicoModule;
